import { FC } from 'react';

const ConfirmCheckIcon: FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M13.5571 6.55896C13.8005 6.31451 14.1962 6.31335 14.4409 6.55651C14.6857 6.7999 14.6867 7.19635 14.4434 7.44112L8.47737 13.4405C8.36006 13.5584 8.20022 13.6252 8.03385 13.6252C7.86749 13.6252 7.70763 13.5584 7.59033 13.4405L5.55664 11.3954C5.31353 11.1507 5.31457 10.7549 5.55908 10.5116C5.80384 10.2682 6.20029 10.2693 6.44368 10.514L8.03385 12.1123L13.5571 6.55896Z"
      fill="#010203"
    />
  </svg>
);

export default ConfirmCheckIcon;
